import { useState, useEffect } from "react";
import { getMyaccountLastPurchases } from "../../../../../global/paywall/paywallApiUrls";
import * as axios from "axios";
import { formatDate } from "../../../../siteWidgets/siteWidgetUtils";
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink"

interface LastPurchaseProperties {
    contactUsPage: { url: string, targetLink: LinkTargetProperties };
    userData: any;
}

const CalcalistPaywallMyAccountLastPurchases = (props: LastPurchaseProperties) => {

    const [lastPurchases, setLastPurchases] = useState([]);
    const [generalError, setGeneralError] = useState('');

    const fetchLastPurchases = async (url) => {
        try {
            const { data, status } = await axios.get(url);
            if (status === 200 && data && (data as any).data) {
                setLastPurchases((data as any).data as []);
            }
        } catch (error) {
            console.error(error);
            setGeneralError("משהו השתבש, נסו שוב מאוחר יותר");
        }
    };

    useEffect(() => {
        fetchLastPurchases(getMyaccountLastPurchases());
    }, [])

    if (generalError) {
        return <div className="CalcalistPaywallMyAccountLastPurchases"><div className="general-error">{generalError}</div></div>
    }

    const getContactUsUrlWithParams = (formData) => {
        try {
            const contactPageUrl = props.contactUsPage.url || 'https://www.calcalist.co.il/';
            const url = new URL(contactPageUrl);
            const params = url.searchParams;
            params.set('firstName', formData.firstName || '');
            params.set('email', formData.email || '');
            params.set('phone', formData.phoneNumber || '');
            params.set('subject', 'בקשה לביטול מנוי');
            params.set('message', `ביטול מנוי ללקוח ל: ${formData.email}
    חבילה - ${lastPurchases[0].packageName}\n`);
            return url.toString();
        } catch (e) {
            console.error('', e);
            return '';
        }
    };

    return (
        <div className="CalcalistPaywallMyAccountLastPurchases">
            <div className="table">
                <div className="header">
                    <span className="header-type">סוג חבילה</span>
                    <span className="header-date">תאריך רכישה</span>
                </div>
                <div className="list">
                    {lastPurchases.map((item, index) => (
                        <div key={index} className="row">
                            <div className="type">{item.packageName} {index === 0 && <HyperLinkBuilder linkTarget={props.contactUsPage.targetLink} href={getContactUsUrlWithParams(props.userData)} className="cancel">ביטול מנוי</HyperLinkBuilder>}</div>
                            <div className="date">{formatDate(new Date(item.purchaseDate), 'DD/MM/YYYY')}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CalcalistPaywallMyAccountLastPurchases;